module.exports = __webpack_public_path__ + "static/fast-skeleton-shimmer-7597c1e06ef191a7319d1ca686ee39ce.gif";